import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {StoreItemActions} from "../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../store/entities/store-item/store-item.model";
import {GET_CAROUSEL_ITEMS} from "../../store/entities/cms/carousel-item/carousel-item.graphql";
import {select, Store} from "@ngrx/store";
import {selectStoreItems} from "../../store/entities/store-item/store-item.selectors";
import {map, Observable} from "rxjs";
import {CarouselItem} from "../../store/entities/cms/carousel-item/carousel-item.model";
import {AppState} from "../../store/reducers";
import {environment} from "../../../environments/environment";
import {ContactCenter, SocialPlatform} from "../../store/entities/cms/contact-centers/contact-centers.model";
import {GET_CONTACT_CENTER_FEWER} from "../../store/entities/cms/contact-centers/contact-centers.graphql";

@Component({
  selector: 'app-guest-carousel',
  templateUrl: './guest-carousel.component.html',
  styleUrl: './guest-carousel.component.scss'
})
export class GuestCarouselComponent implements OnInit, OnDestroy {
  socialMediaLinks = [
    {
      name: 'Instagram',
      icon: 'instagram_coloured',
      link: 'https://www.instagram.com'
    },
    {
      name: 'X',
      icon: 'x',
      link: 'https://x.com',
    },
    {
      name: 'Youtube',
      icon: 'youtube_coloured',
      link: 'https://www.youtube.com'
    },
    {
      name: "Oxygen",
      icon: 'oxygen',
      link: 'https://www.maadili.go.tz'
    }
  ]
  intervalId: any;
  carouselItems$: Observable<CarouselItem[]>
  contactCenters$: Observable<ContactCenter>
  activeCarousel = 0;
  images: string[];
  fileUrl = environment.FILE_SERVER_URL;
  platform = SocialPlatform;
  store = inject(Store<AppState>);

  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.carouselItem,
      query: GET_CAROUSEL_ITEMS,
      filtering: {}
    }))
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.contactCenter,
      query: GET_CONTACT_CENTER_FEWER,
      filtering: {
        isSystemContact: true
      }
    }))
    this.carouselItems$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.carouselItem))).pipe(map((x: CarouselItem[]) => {
      this.images = this.carouselImages(x);
      return x;
    }))

    this.contactCenters$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.contactCenter))).pipe(map((x: ContactCenter[]) => {
      console.log(x);
      if (x?.length > 0) return x[0];
      return null;
    }))
    this.intervalId = setInterval(() => this.nextSlide(), 4000);
  }

  showSlide(index) {
    this.activeCarousel = index;
  }

  nextSlide() {
    this.activeCarousel = (this.activeCarousel + 1) % this.images.length;
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  carouselImages(carouselItems: CarouselItem[]) {
    return carouselItems?.map(x => x?.image);
  }

  getSocialMediaIcon(platform: string): string {
    const iconMap = {
      Facebook: 'facebook',
      Twitter: 'x',
      Instagram: 'instagram_coloured',
      Linkedin: 'linkedin_coloured',
      Youtube: 'youtube_coloured',
      Whatsapp: 'whatsapp_coloured',
      Telegram: 'telegram_coloured',
      Tiktok: 'tiktok_coloured',
      Other: 'globe'
    };
    return iconMap[platform] || 'globe';
  }
}
